import React, {useContext, useState} from 'react';
import StatisticsBox from "../../components/adviser/Dashboard/StatisticsBox";
import CotizacionesTable from "../../components/adviser/Dashboard/CotizacionesTable";
import './AdviserStyles.css'
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AdviserSideNavBar from "../../components/adviser/Dashboard/Sidebar/AdviserSideNavBar";
import useWindowDimensions from "../../useWindowDimensions";
import UserContext from "../../context/UserContext";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {Button} from "@material-ui/core";


const useStyles = makeStyles(theme => ({
    tableTitle: {
        fontFamily: "EncodeSansBold",
        fontSize: "20px",
        color: "#3b3b3b",
    },
    statisticsBox: {
        backgroundColor: "#FFF",
        borderRadius: "20px",
        width: "1032px",
        padding: "16px",
        boxShadow: "5px 10px 18px #888888",
        display: "flex",
        flexDirection: "column",
        overflowY: "hidden"
    },
    statisticsBoxHeader: {
        display: "flex",
        justifyContent: "space-between",
        margin: '0px 16px 8px 16px'
    },
    statisticsBoxBody: {
        padding: "0 32px"
    },
    parentColumn: {
        display: "flex",
        flexDirection: "column",
        position: "relative",
    },
    bodyColumn: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        marginTop: "88px",
    },
    divHeader: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        position: "absolute"
    },
}))

const DashboardAdviser = () => {
    const classes = useStyles();
    const {width} = useWindowDimensions();
    const {open} = useContext(UserContext);
    const [collapsed, setCollapsed] = useState(true);

    return (
        <React.Fragment>
            <div className={classes.parentColumn}>
                <div className={classes.divHeader}>
                    <AdviserSideNavBar role="Asesor"/>
                </div>
                <div
                    className={classes.bodyColumn}
                    style={{
                        left: open ? "240px" : "60px",
                        transitionProperty: "left",
                        transitionDuration: "1s",
                        width: open ? `${width - 260}px` : `${width - 80}px`,
                    }}>

                    <div className={classes.statisticsBox}
                         style={{
                             transitionProperty: "height",
                             transitionDuration: "1s",
                             height: collapsed ? `195px` : `596px`,
                         }}>
                            <div className={classes.statisticsBoxHeader}>
                                <h3 className={classes.tableTitle}>Estadísticas</h3>
                                <Button
                                    onClick={() => setCollapsed(!collapsed)}
                                >
                                    {collapsed ? <ExpandMoreIcon style={{color: "#bb0d66"}}/> : <ExpandLessIcon style={{color: "#bb0d66"}}/>}
                                </Button>
                            </div>
                            <div className={classes.statisticsBoxBody}>
                                <StatisticsBox/>
                            </div>
                    </div>
                    <div className="cotizaciones-box"
                         style={{display: "flex", flexDirection: "row", padding: "16px", margin: "24px 0 50px 0"}}>

                        <Grid item style={{padding: '8px', width: "100%"}}>
                            <CotizacionesTable/>
                        </Grid>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
};

export default DashboardAdviser;
